import {
  CALCULATE_AWARDS,
  GET_AD_NETWORKS_TYPES,
  SET_AD_NETWORKS_TYPES,
  RESET_AD_NETWORKS_TYPES,
  SET_CALCULATE_AWARDS,
  RESET_CALCULATE_AWARDS,
} from 'modules/PartnersProgram/types'

export const getAdNetworksTypesAction = (props) => ({
  type: GET_AD_NETWORKS_TYPES,
  payload: props,
})

export const calculateAwardsAction = (props) => ({
  type: CALCULATE_AWARDS,
  payload: props,
})

export const setAdNetworksTypesAction = (props) => ({
  type: SET_AD_NETWORKS_TYPES,
  payload: props,
})

export const resetAdNetworksTypesAction = () => ({
  type: RESET_AD_NETWORKS_TYPES,
})

export const setCalculateAwardsAction = (props) => ({
  type: SET_CALCULATE_AWARDS,
  payload: props,
})

export const resetCalculateAwardsAction = () => ({
  type: RESET_CALCULATE_AWARDS,
})
